import { render, staticRenderFns } from "./Delivery_Boundary.vue?vue&type=template&id=357270cc&"
import script from "./Delivery_Boundary.vue?vue&type=script&lang=js&"
export * from "./Delivery_Boundary.vue?vue&type=script&lang=js&"
import style0 from "./Delivery_Boundary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports